@let order = this.order();

<div class="details-grid">
  <div class="order-details">
    <h2 class="section-title">{{ 'order_success.order_info' | translate }}</h2>
    <div class="order-info">
      <div class="order-info-label">{{ 'order_success.receiver' | translate }}</div>
      <div class="order-info-value">
        {{ order.shipment.recipient.contactInfo.firstName }} {{ order.shipment.recipient.contactInfo.lastName }}
        @if (order.shipment.recipient.contactInfo.phoneNumber; as phoneNumber) {
          <span class="recipient-phone">{{ phoneNumber | mask: PHONE_NUMBER_MASK }}</span>
        }
      </div>
    </div>
    <div class="order-info">
      <div class="order-info-label">
        {{ 'global.shipment_method' | translate }}:
      </div>
      <div class="order-info-value">
        {{ order.shipment.shippingMethodDescription }}
        @if (isShippingMethodDelivery() && shipmentPayerRecipient() !== undefined) {
          <span class="shipment-payer">
            {{ (shipmentPayerRecipient() ? 'global.recipient_payer' : 'global.sender_payer') | translate }}
          </span>
        }
      </div>
    </div>
    @if (isShippingMethodDelivery()) {
      <div class="order-info order-info-wide">
        <div class="order-info-label">
          {{ 'global.delivery' | translate }}:
        </div>
        <div class="order-info-value">
          {{ order.shipment.recipient.address.settlementNameFull || order.shipment.recipient.address.settlementName }}, {{ order.shipment.recipient.address.addressNameFull || order.shipment.recipient.address.addressName }}
          @if (order.shipment.recipient.address.buildingNumber; as buildingNumber) {
            <span>, {{ buildingNumber }}</span>
          }
          @if (order.shipment.recipient.address.flat; as flat) {
            <span>, {{ flat }}</span>
          }
        </div>
      </div>
    }
    @if (order.note; as note) {
      <div class="order-info order-info-wide">
        <div class="order-info-label">
          {{ 'account_orders.comment' | translate }}:
        </div>
        <div class="order-info-value">
          {{ note }}
        </div>
      </div>
    }
    <div class="order-info">
      <div class="order-info-label">
        {{ 'global.is_callback_needed' | translate }}
      </div>
      <div class="order-info-value">
        @switch (order.isCallbackNeeded) {
          @case (true) {
            {{ 'global.yes' | translate }}
          }
          @case (false) {
            {{ 'global.no' | translate }}
          }
        }
      </div>
    </div>
    @if (order.shipment.trackingNumber) {
      <div class="order-info">
        <div class="order-info-label">
          {{ 'account_orders.tracking_number' | translate }}:
        </div>
        <div class="order-info-value">
          {{ order.shipment.trackingNumber }}
        </div>
      </div>
    }
    @if (order.shipment.statusDescription) {
      <div class="order-info">
        <div class="order-info-label">
          {{ 'account_orders.tracking_status' | translate }}:
        </div>
        <div class="order-info-value">
          {{ order.shipment.statusDescription }}
        </div>
      </div>
    }
    <ng-content />
  </div>
  <div class="order-products">
    <h2 class="section-title">{{ 'order_success.order_items' | translate }}</h2>
    @for (item of order.items; track item.productId) {
      <div class="order-item item">
        <img
          class="order-img item-img"
          [src]="item.imageUrl"
          [alt]="item.name"
          loading="lazy"
        >
        <div class="item-description">
          <a
            class="item-name g-main-link"
            [routerLink]="['/', item.slug]"
            target="_blank"
            routerLinkWithLang
          >
            {{ item.name }}
          </a>
          @if (item.additionalServices?.length) {
            <div class="item-additional-services">
              @for (service of item.additionalServices; track service.id) {
                <div class="item-additional-service">
                  {{ service.name }} (+{{ service.price }}{{ 'global.uah' | translate }})
                </div>
              }
            </div>
          }
        </div>
        <div class="item-price-container">
          {{ item.price }} {{ 'global.uah' | translate }} <span class="item-qty">× {{ item.qty }} {{ 'global.pcs.' | translate }}</span>
        </div>
        <div class="item-cost-container">
          <div
            class="item-cost"
            [class.item-cost-special]="item.oldCost"
          >
            {{ item.cost }} {{ 'global.uah' | translate }}
          </div>
          @if (item.oldCost) {
            <del class="item-old-cost">{{ item.oldCost }} {{ 'global.uah' | translate }}</del>
          }
        </div>
      </div>
    }
    <dl class="order-summary">
      <div class="summary-row">
        <dt>{{ 'global.payment' | translate }}</dt>
        <dd>{{ order.paymentMethodName }}</dd>
      </div>
      <div class="summary-row">
        <dt>{{ 'account_orders.payment_status' | translate }}</dt>
        <dd
          class="payment-status"
          [class.payment-status-paid]="order.isPaid"
        >
          {{ (order.isPaid ? 'account_orders.paid' : 'account_orders.unpaid') | translate }}
        </dd>
      </div>
      @if (order.prices.discountValue; as discountValue) {
        <div class="summary-row">
          <dt>{{ 'global.items_cost' | translate }}</dt>
          <dd>{{ order.prices.itemsCost }} {{ 'global.uah' | translate }}</dd>
        </div>
        <div class="summary-row">
          <dt>{{ 'global.discount' | translate }}</dt>
          <dd>{{ discountValue }} {{ 'global.uah' | translate }}</dd>
        </div>
      }
      <div class="summary-row summary-total">
        <dt>{{ 'account_orders.total' | translate }}</dt>
        <dd>{{ order.prices.totalCost }} {{ 'global.uah' | translate }}</dd>
      </div>
    </dl>
  </div>
</div>
